// extracted by mini-css-extract-plugin
export var grid1 = "GenericGrid-module__grid1--2h_vt";
export var grid2 = "GenericGrid-module__grid2--id6CO";
export var grid3 = "GenericGrid-module__grid3--104vy";
export var grid4 = "GenericGrid-module__grid4--2aFQf";
export var gridItem = "GenericGrid-module__gridItem---fUCE";
export var horizontalAlignCenter = "GenericGrid-module__horizontalAlignCenter--_D7CP";
export var horizontalAlignLeft = "GenericGrid-module__horizontalAlignLeft--3JyzW";
export var horizontalAlignRight = "GenericGrid-module__horizontalAlignRight--1l5ZX";
export var indentLarge = "GenericGrid-module__indentLarge--2SANJ";
export var indentMedium = "GenericGrid-module__indentMedium--3CFBS";
export var indentSmall = "GenericGrid-module__indentSmall--1Wajr";
export var ratio11 = "GenericGrid-module__ratio-1-1--pJfaG";
export var ratio12 = "GenericGrid-module__ratio-1-2--3CGoP";
export var ratio13 = "GenericGrid-module__ratio-1-3--1O-nO";
export var ratio21 = "GenericGrid-module__ratio-2-1--2iczR";
export var ratio31 = "GenericGrid-module__ratio-3-1--WEdB-";
export var verticalAlignBottom = "GenericGrid-module__verticalAlignBottom--2lkOo";
export var verticalAlignCenter = "GenericGrid-module__verticalAlignCenter--2bcQP";
export var verticalAlignTop = "GenericGrid-module__verticalAlignTop--10aXy";